export type ChallengesReducer = {
  ideaFilter: string;
  tagFilter: string[];
  ideaIncludes: "submitted" | "draft" | "all";
  groupFilter: string[];
  labelsFilter: string[];
  orgFilter: string[];
  ideaOrder:
    | "createdAt"
    | "default"
    | "score"
    | "updatedAt"
    | "voteCount"
    | "completeness"
    | "field+";
  ideaOrderDirection: "asc" | "desc";
  ideaPage: number;
  ideaLimit: number;
  ideaFieldChoices: string[];
  projectBoardFilter: ("assignedToMe" | "unassigned" | "assignedTo+")[];
  projectBoardLanesFilter: string[];
  ideaViewType: "card" | "list" | "board";
  filtersVisible: boolean;
  adminHasCommented: "commented" | "notCommented" | "all";
  impactFilter: string[];
};

export type ChallengesAction =
  | { type: "UPDATE_IDEA_FILTERS"; data: Partial<ChallengesReducer> }
  | {
      type: "SET_IDEA_VIEW_TYPE";
      ideaViewType: ChallengesReducer["ideaViewType"];
    };

const initialState: ChallengesReducer = {
  ideaFilter: "",
  tagFilter: [],
  ideaIncludes: "all",
  groupFilter: [],
  labelsFilter: [],
  orgFilter: [],
  ideaOrder: "default",
  ideaOrderDirection: "desc",
  ideaPage: 1,
  ideaLimit: 16,
  ideaFieldChoices: [],
  projectBoardLanesFilter: [],
  ideaViewType: "card",
  filtersVisible: false,
  adminHasCommented: "all",
  projectBoardFilter: [],
  impactFilter: [],
};

export const defaultInitialState: ChallengesReducer = { ...initialState };

function challenges(
  state = initialState,
  action: ChallengesAction,
): ChallengesReducer {
  switch (action.type) {
    case "UPDATE_IDEA_FILTERS":
      return { ...state, ...action.data };
    case "SET_IDEA_VIEW_TYPE": {
      // Opening an idea on the board re-applies this action via search
      // params; keep existing filters unless the view type actually changed.
      if (action.ideaViewType === state.ideaViewType) {
        return state;
      }
      return {
        ...state,
        ideaViewType: action.ideaViewType,
        ideaLimit: action.ideaViewType === "card" ? 16 : 30,
        ideaIncludes:
          action.ideaViewType === "board"
            ? "submitted"
            : state.ideaViewType === "board"
              ? "all"
              : state.ideaIncludes,
      };
    }
    default:
      return state;
  }
}

export default challenges;
